import React, { useState } from 'react';
import { Accordion, Card } from "react-bootstrap";
import MinimizeIcon from "@material-ui/icons/Minimize";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";

import {
  CardHeader,
  ModalObservation,
  AddIconStyles,
  MinimizeIconStyles,
  ObservationContent,
  ButtonOutline
} from "./styles";
import { OutlineGrayButton } from "~/components/layout/Buttons";

export default function Observation({
  desktopObservationActive,
  addObservation,
  date,
  observation
}) {
  const [writingTextArea, setWritingTextarea] = useState("")

  return(
    <>
      {date !== "" ? (
        <Accordion style={{ margin: "0 0 2rem 0" }}>
          <Card.Header
            style={CardHeader}
            onClick={() => desktopObservationActive()}
          >
            Observações
            <EditIcon />
          </Card.Header>
          <Card style={{ boxShadow: '0px 2px 4px #00000033' }}>
            {desktopObservationActive(true) ? (
              <ModalObservation>
                <textarea
                  maxLength="255"
                  placeholder="Descreva aqui..."
                  onChange={(e) =>
                    setWritingTextarea(e.target.value)
                  }
                >
                  {observation !== "Nenhuma observação"
                    ? observation
                    : ""}
                </textarea>
                <div style={{ justifyContent: 'center', alignItems: 'center' }}>
                  <ButtonOutline
                    style={{ width: '54%', justifyContent: 'center'}}
                    outline
                    onClick={() => {
                      addObservation(writingTextArea);
                      desktopObservationActive();
                    }}
                  >
                    <div style={{ justifyContent: 'center'}}>Salvar</div>
                  </ButtonOutline>
                </div>
              </ModalObservation>
            ) : (
              <ObservationContent onClick={() => desktopObservationActive()}>
                {observation === ""
                  ? "Nenhuma observação"
                  : observation.length > 50
                  ? observation.substring(0, 50) + "..."
                  : observation.substring(0, 50)}
              </ObservationContent>
            )}
          </Card>
        </Accordion>
      ) : null}
    </>
  );
}
